import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import diya from '../resources/brand/diya.png';
import { isShowDiwaliDiya } from '../special-params';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(1),
    },

    '& img': {
      display: 'flex',
      width: 29,
      height: 'auto',
      alignItems: 'center',
    },
  },
}));

const DiwaliDiya = () => {
  const classes = useStyles();

  if (!isShowDiwaliDiya) {
    return <></>;
  }

  return (
    <div className={`${classes.root} DiwaliDiya`}>
      <img src={diya} alt="diya" />
    </div>
  );
};

export default DiwaliDiya;
